<template>
  <v-container fluid class="theme-color" style="height: 100%;">
    <v-row class="card pb-4 mt-5" justify-space-between>
      <v-col cols="12">
        <Report />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Report from '../components/dashboard_report/Report.vue';

export default {
  name: 'Dashboard',
  components: {
    Report
  },
  data: () => ({}),
  mounted() {
    this.$emit('sethambergervisible', true);
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.card {
  width: 85% !important;
  background: none;
  margin: auto;
}

.col {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
